<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16 2C19.3137 2 22 4.68629 22 8V16C22 19.3137 19.3137 22 16 22H8C4.68629 22 2 19.3137 2 16V8C2 4.68629 4.68629 2 8 2H16ZM8 5.5C6.89543 5.5 6 6.39543 6 7.5V16.5C6 17.6046 6.89543 18.5 8 18.5H11L11.1025 18.4951C11.6067 18.4438 12 18.0177 12 17.5C12 16.9823 11.6067 16.5562 11.1025 16.5049L11 16.5H8V7.5H11L11.1025 7.49512C11.6067 7.44379 12 7.01768 12 6.5C12 5.98232 11.6067 5.55621 11.1025 5.50488L11 5.5H8ZM14.7783 7.82031C14.385 7.39298 13.7283 7.39298 13.335 7.82031L10.1533 11.2773L10.0879 11.3555C9.80363 11.7326 9.80363 12.2674 10.0879 12.6445L10.1533 12.7227L13.335 16.1797C13.7283 16.607 14.385 16.607 14.7783 16.1797C15.1496 15.7763 15.1494 15.1379 14.7783 14.7344L13.2295 13.0518L17.8711 13.0869H17.875C18.4655 13.0869 18.875 12.5793 18.875 12.043C18.8749 11.5079 18.4672 11.0032 17.8789 11.001V11L13.2139 10.9658L14.7783 9.26562C15.1494 8.8621 15.1496 8.22374 14.7783 7.82031Z"
      fill="currentColor"
    />
  </svg>
</template>